import { render } from "./SectionIndexProfile.vue?vue&type=template&id=44590bf2&scoped=true"
import script from "./SectionIndexProfile.vue?vue&type=script&lang=js"
export * from "./SectionIndexProfile.vue?vue&type=script&lang=js"

import "./SectionIndexProfile.vue?vue&type=style&index=0&id=44590bf2&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44590bf2"]])

export default __exports__